import {getTranslationKey} from '@hconnect/common/utils'
import {Error404Page as BaseError404Page} from '@hconnect/uikit/src/lib2'
import {useTranslation} from 'react-i18next'
import {Link} from 'react-router'

import {useTranslationPrefix} from '../../shared/hooks'

type Props = {
  goToLink?: string
}

export const ShiftsRequiredErrorPage = ({goToLink = '/'}: Props) => {
  const {t} = useTranslation()
  const {hrocPrefix} = useTranslationPrefix()

  return (
    <BaseError404Page
      caption={t(getTranslationKey('shiftsRequiredErrorPage.title', hrocPrefix))}
      description={t(getTranslationKey('shiftsRequiredErrorPage.description', hrocPrefix))}
      goToCaption={t(getTranslationKey('shiftsRequiredErrorPage.goToHome', hrocPrefix))}
      goToLink={goToLink}
      RouterLink={Link}
    />
  )
}
